import { InteractionType } from '@azure/msal-browser';
import { useMsal, useMsalAuthentication } from '@azure/msal-react';
import { useEffect } from 'react';

/**
 * Login using sso, and falling back to popup on error
 * @constructor
 */
export const SsoAuthFlow = () => {
  const { instance } = useMsal();
  const redirectStartPage = window.location.href;
  const {
    auth: {
      OIDCOptions: { defaultScopes: scopes },
    },
  } = instance.getConfiguration();
  const { login, error } = useMsalAuthentication(InteractionType.Redirect, {
    // only required to explicitly pass redirectStartPage
    scopes,
    redirectStartPage,
  });
  useEffect(() => {
    if (error) {
      login(InteractionType.Popup).then((res) => {
        instance.setActiveAccount(res.account);
      });
    }
  }, [error]);
  return <></>;
};
